export const conversationMessageNotificationType = 'CONVERSATION_MESSAGE';

export const supportSenderData = {
  first_name: 'Gravy',
  last_name: 'Support',
  photo_image_url: 'https://s3.amazonaws.com/gravy-media-alpha/avatars/512pt_%401x.png'
};

export const conversationTypes = {
  job: 'job',
  direct: 'direct'
};

export const directConversationsSubTypes = {
  private: 'private',
  group: 'group',
  support: 'support'
};



// WEBPACK FOOTER //
// ./src/constants/conversations.js